import SettingFrame from "../../../../components/@settings/SettingFrame"

import SmsSetting from "../../../../components/@settings/sms/SmsSetting"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SMSPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <SmsSetting
                routeType={routeType}
            />
        </SettingFrame>
    )
}       